import { useOutsideClick as e } from "../hooks/use-outside-click.js";
import { useUiContext as t } from "./ui-provider.js";
import { Popover as n } from "../../../popover/index2.js";
import { getStyles as r } from "../../../popover/style.js";
import i from "react";
import { jsx as a, jsxs as o } from "react/jsx-runtime";
// src/design/forms/datepicker/ui/calendar-popover.tsx
var s = ({ trigger: s, content: c }) => {
	let l = i.useRef(null), u = i.useRef(null), { isOpen: d, close: f } = t();
	return e({
		ref: l,
		handler: (e) => {
			u.current && !u.current.contains(e.target) && d && f();
		}
	}), /* @__PURE__ */ a("div", {
		ref: l,
		children: /* @__PURE__ */ o(n.Root, {
			autoFocus: !1,
			open: d,
			lazyMount: !0,
			children: [/* @__PURE__ */ a(n.Anchor, {
				asChild: !0,
				children: /* @__PURE__ */ a("div", {
					className: "w-fit",
					children: s
				})
			}), /* @__PURE__ */ a(n.Portal, { children: /* @__PURE__ */ a(n.Positioner, { children: /* @__PURE__ */ o(n.Content, {
				className: r().content("p-0.5"),
				ref: u,
				children: [/* @__PURE__ */ a(n.Arrow, { children: /* @__PURE__ */ a(n.ArrowTip, {}) }), c]
			}) }) })]
		})
	});
};
export { s as CalendarPopover };

//# sourceMappingURL=calendar-popover.js.map